 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-09ed200b":"5f20c479","chunk-13d7b9da":"14ec7bb6","chunk-168915b6":"f6bafee8","chunk-043d6e82":"991193d7","chunk-1b6e3c9e":"c0790df4","chunk-27432747":"e2df7e44","chunk-63598708":"5654758b","chunk-6b57f6b9":"8b6b9991","chunk-1867d8ea":"580312ab","chunk-19bafec0":"77e58458","chunk-1cc31386":"4510977c","chunk-1e2fbcc9":"0c643d6f","chunk-2530287c":"6c2b4884","chunk-25ca9837":"13ed99a0","chunk-2b2df1fa":"80bc6be3","chunk-2d0b25d5":"b861b12b","chunk-2d0c4c04":"4a442fea","chunk-2d230676":"388c52e8","chunk-e834e798":"6941eec1","chunk-2d0d83c6":"8a0c0a08","chunk-60ae1b9f":"bb82a1fd","chunk-20474686":"c4303482","chunk-6b900cc5":"676c2e7e","chunk-73de1d53":"85590c35","chunk-3c9916f2":"74cb0069","chunk-65b7fc70":"48bb4bd0","chunk-a7bd0b12":"04ca09bb","chunk-89d07706":"7f39f77d","chunk-709042dc":"29435d9d","chunk-7a155d5c":"29737ed6","chunk-2d210315":"c4e6cc31","chunk-324289bf":"10f33243","chunk-38784080":"8c0ac999","chunk-3b032d30":"8506e5c0","chunk-3c2103c2":"a52002e4","chunk-3e36a440":"a3842d26","chunk-436d3d83":"98600ec7","chunk-4a4c86a3":"03fe6c47","chunk-58b47f9e":"9c5a3a5e","chunk-2760d5ba":"99d31ad7","chunk-55a9d00b":"6f550282","chunk-048e74d4":"454cc0b1","chunk-6598ce10":"10f81663","chunk-67c89191":"f9944c04","chunk-6f799e16":"e59b914d","chunk-5e1a1946":"9b036fc8","chunk-7a4aa3ca":"eba2ee25","chunk-9c7d231c":"8625a729","chunk-ba9d261a":"48918818","chunk-c4f6de94":"06ef614b","chunk-e4bb94be":"c0be69a7","chunk-e69b9c00":"66089b6e","chunk-ebb95c2e":"2d87df21","chunk-f48cfeee":"e852d26e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-09ed200b":1,"chunk-13d7b9da":1,"chunk-168915b6":1,"chunk-043d6e82":1,"chunk-1b6e3c9e":1,"chunk-27432747":1,"chunk-63598708":1,"chunk-6b57f6b9":1,"chunk-1867d8ea":1,"chunk-19bafec0":1,"chunk-1cc31386":1,"chunk-1e2fbcc9":1,"chunk-2530287c":1,"chunk-25ca9837":1,"chunk-2b2df1fa":1,"chunk-e834e798":1,"chunk-60ae1b9f":1,"chunk-20474686":1,"chunk-6b900cc5":1,"chunk-73de1d53":1,"chunk-3c9916f2":1,"chunk-65b7fc70":1,"chunk-a7bd0b12":1,"chunk-89d07706":1,"chunk-709042dc":1,"chunk-7a155d5c":1,"chunk-324289bf":1,"chunk-38784080":1,"chunk-3b032d30":1,"chunk-3c2103c2":1,"chunk-3e36a440":1,"chunk-436d3d83":1,"chunk-4a4c86a3":1,"chunk-58b47f9e":1,"chunk-2760d5ba":1,"chunk-55a9d00b":1,"chunk-048e74d4":1,"chunk-6598ce10":1,"chunk-67c89191":1,"chunk-6f799e16":1,"chunk-5e1a1946":1,"chunk-7a4aa3ca":1,"chunk-9c7d231c":1,"chunk-ba9d261a":1,"chunk-c4f6de94":1,"chunk-e4bb94be":1,"chunk-e69b9c00":1,"chunk-ebb95c2e":1,"chunk-f48cfeee":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-09ed200b":"3b58f005","chunk-13d7b9da":"4fda88a4","chunk-168915b6":"4c637033","chunk-043d6e82":"f5c28ba6","chunk-1b6e3c9e":"47005cea","chunk-27432747":"77217f19","chunk-63598708":"4f0a9702","chunk-6b57f6b9":"fdff6119","chunk-1867d8ea":"32b7c2c3","chunk-19bafec0":"cfb8df55","chunk-1cc31386":"0c1f2978","chunk-1e2fbcc9":"fa54800c","chunk-2530287c":"10def5d9","chunk-25ca9837":"95befa39","chunk-2b2df1fa":"ee799152","chunk-2d0b25d5":"31d6cfe0","chunk-2d0c4c04":"31d6cfe0","chunk-2d230676":"31d6cfe0","chunk-e834e798":"a132c50d","chunk-2d0d83c6":"31d6cfe0","chunk-60ae1b9f":"555ffd0c","chunk-20474686":"7f723070","chunk-6b900cc5":"27f84aba","chunk-73de1d53":"df36a2a8","chunk-3c9916f2":"970d3832","chunk-65b7fc70":"daa00249","chunk-a7bd0b12":"ddaacf6a","chunk-89d07706":"badb2376","chunk-709042dc":"d9bf2e67","chunk-7a155d5c":"32940ee9","chunk-2d210315":"31d6cfe0","chunk-324289bf":"22bb8d36","chunk-38784080":"5147202f","chunk-3b032d30":"347ea8f3","chunk-3c2103c2":"eb2abddf","chunk-3e36a440":"6ba4a781","chunk-436d3d83":"8f9b5dc7","chunk-4a4c86a3":"5c6b123d","chunk-58b47f9e":"570b9230","chunk-2760d5ba":"c421f799","chunk-55a9d00b":"5319e7ba","chunk-048e74d4":"8188679f","chunk-6598ce10":"20de2d2c","chunk-67c89191":"29c1f424","chunk-6f799e16":"033f470f","chunk-5e1a1946":"9ff45469","chunk-7a4aa3ca":"6636ba41","chunk-9c7d231c":"b7952e14","chunk-ba9d261a":"49c50e8f","chunk-c4f6de94":"ed31d66e","chunk-e4bb94be":"e1d7619a","chunk-e69b9c00":"9e9a58a9","chunk-ebb95c2e":"12b2eff9","chunk-f48cfeee":"cda7e51c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/learn/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
